
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lorethree/[slug]",
      function () {
        return require("private-next-pages/lorethree/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lorethree/[slug]"])
      });
    }
  